void (function () {
  if (typeof jQuery === "undefined") {
    console.error("[Stoq] jQuery is required but not loaded");
    return;
  }

  const $ = jQuery;

  // Handles Stoq API interactions for back in stock notifications and email subscriptions
  class StoqApiHandler {
    constructor() {
      // API configuration for Stoq integration
      this.config = {
        ENDPOINTS: {
          BACK_IN_STOCK: "https://app.restockrocket.io/api/v1/intents.json",
        },
      };

      this.initializeEventListeners();
    }

    initializeEventListeners() {
      $(document).on(
        "click",
        "#back-in-stock.stoq-app #notify",
        this.handleBackInStockForm.bind(this)
      );
      $(document).on(
        "click",
        "#coming-soon.stoq-app #coming_soon_notify",
        this.handleComingSoonForm.bind(this)
      );
      $(document).on(
        "click",
        "#restocking-soon.stoq-app #restocking_soon_notify",
        this.handleRestockingSoonForm.bind(this)
      );
    }

    // RFC 5322 compliant email validation
    validateEmail(email, inputSelector) {
      const emailPattern =
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      const isValid = emailPattern.test(email);

      if (!isValid) {
        $(inputSelector)
          .val("")
          .attr("placeholder", window.languages.productNotifyInvalidEmail)
          .addClass("error");
      } else {
        $(inputSelector).removeClass("error");
      }

      return isValid;
    }

    // Back in Stock Success Callbacks
    onBackInStockSuccess(email, variantID) {
      console.info("[Stoq] Back in stock subscription successful", {
        email,
        variantID,
      });
    }

    // Back in Stock Subscription Error Callbacks
    onBackInStockError(error, email, variantID) {
      console.error("[Stoq] Back in stock subscription failed", {
        error: error.message,
        email,
        variantID,
      });
    }

    // Update back in stock UI
    updateBackInStockUI() {
      $("div#back-in-stock").removeClass("show");
      $(".ProductForm__AddToCart").css("display", "none");
      $(".notify-success-message").css("display", "block");
      $(".SizeSwatch").css("pointer-events", "none");

      // Reset UI after 5 seconds
      setTimeout(() => {
        $(".notify-success-message").css("display", "none");
        $(".ProductForm__AddSize").removeClass("hide");
        $(".ProductForm__AddSize").css("display", "block");
        $("span.ProductForm__Label.ProductForm__quantity_Label").css(
          "display",
          "block"
        );
        $(".ProductForm__QuantitySelector").css("display", "block");
        $(".SizeSwatch").css("pointer-events", "auto");
      }, 5000);
    }

    // Update coming soon UI
    updateComingSoonUI() {
      $("#coming-soon .input-button-wrapper").css("display", "none");
      $("#coming-soon .notify-success-message").css("display", "block");

      // Reset UI after 5 seconds
      setTimeout(() => {
        $("#coming-soon .notify-success-message").css("display", "none");
        $("#coming-soon .input-button-wrapper").css("display", "block");
      }, 5000);
    }

    // Update restocking soon UI
    updateRestockingSoonUI() {
      $("#restocking-soon .input-button-wrapper").css("display", "none");
      $("#restocking-soon .notify-success-message").css("display", "block");

      // Reset UI after 5 seconds
      setTimeout(() => {
        $("#restocking-soon .notify-success-message").css("display", "none");
        $("#restocking-soon .input-button-wrapper").css("display", "block");
      }, 5000);
    }    
    
    // Create Stoq back in stock API payload
    getBackInStockPayload(email) {
      const productDataEl = document.querySelector("[data-product-json]");

      if (!productDataEl || !productDataEl.textContent.trim()) {
        console.error("[Stoq] Product data not found");
        return;
      }

      const { product: productData } = JSON.parse(productDataEl.textContent);
      
      const variantID = $(".ProductForm__Variants select")
        .find(":selected")
        .val();
        
      const variantTitle = productData.variants.find(v => v.id === Number(variantID))?.title || "";
      const variantSku = productData.variants.find(v => v.id === Number(variantID))?.sku || "";

      const productId = productData.id;
      const marketId = document.documentElement.dataset.marketId;

      const payload = {
        intent: {
          shopify_variant_id: variantID,
          shopify_product_id: productId,
          shopify_market_id: marketId,
          quantity: 1,
          source: "restock-rocket-extension",
        },
        customer: {
          accepts_marketing: false,
          locale: "en",
          shopify_market_id: marketId,
          email,
        },
        product: {
          title: productData.title,
          variant_title: variantTitle,
          variant_count: productData.variant_count,
          vendor: productData.vendor,
          sku: variantSku,
        },
      };
      
      return payload
    }

    // Handle back in stock form submission
    async handleBackInStockForm(e) {
      e.preventDefault();

      const email = $("#notify_email").val();
      if (!this.validateEmail(email, "#notify_email")) {
        console.error("[Stoq] Invalid email address");
        return;
      }

      const payload = this.getBackInStockPayload(email);

      if (!payload) {
        return;
      }     

      try {
        await this.backInStockSubscription(payload);
        this.updateBackInStockUI();
      } catch (error) {
        console.error("[Stoq] Back In Stock form submission failed", {
          error: error.message,
        });
      }
    }

    // Handle coming soon form submission
    async handleComingSoonForm(e) {
      e.preventDefault();

      const email = $("#coming_soon_notify_email").val();
      if (!this.validateEmail(email, "#coming_soon_notify_email")) {
        console.error("[Stoq] Invalid email address");
        return;
      }

      const payload = this.getBackInStockPayload(email);

      if (!payload) {
        return;
      }

      try {
        await this.backInStockSubscription(payload);
        this.updateComingSoonUI();
      } catch (error) {
        console.error("[Stoq] Coming soon form submission failed", {
          error: error.message,
        });
      }
    }
    
    // Handle restocking soon form submission
    async handleRestockingSoonForm(e) {
      e.preventDefault();

      const email = $("#restocking_soon_notify_email").val();
      if (!this.validateEmail(email, "#restocking_soon_notify_email")) {
        console.error("[Stoq] Invalid email address");
        return;
      }

      const payload = this.getBackInStockPayload(email);

      if (!payload) {
        return;
      }

      try {
        await this.backInStockSubscription(payload);
        this.updateRestockingSoonUI();
      } catch (error) {
        console.error("[Klaviyo] Restocking soon form submission failed", {
          error: error.message,
        });
      }
    }    

    // Register back in stock notification for a specific variant
    async backInStockSubscription(payload) {
      const endpoint = this.config.ENDPOINTS.BACK_IN_STOCK;
      const options = {
        method: "POST",
        headers: {
          accept: "application/json",
          "content-type": "application/json",
          "x-shopify-shop-domain": Shopify.shop,
          "x-shopify-theme-schema-name": "Prestige",
          "x-shopify-theme-schema-version": "5.7.0",
          "x-shopify-theme-store-id": "null",
        },
        referrer: `https://${Shopify.shop}/`,
        body: JSON.stringify(payload),
        method: "POST",
        mode: "cors",
        credentials: "omit",
      };

      try {
        const response = await fetch(endpoint, options);
        if (!response.ok) throw new Error("Network response was not ok");

        this.onBackInStockSuccess(payload.customer.email, payload.intent.shopify_variant_id);
        return response;
      } catch (error) {
        this.onBackInStockError(error, payload.customer.email, payload.intent.shopify_variant_id);
        throw error;
      }
    }
  }

  new StoqApiHandler();
})();
